import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted } from './vue.esm-browser.prod.js';
// import { productsData, reportData } from './data';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger, KTab } from './common/k-tools/k-tools.js';
import LazyLoad from 'vanilla-lazyload';
// import Swiper bundle with all modules installed
import { Swiper } from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation';

const swiperHandler = () => {
  const bannerSwiper = new Swiper('.bannerSwiper', {
    loop: true,
    autoplay: {
      delay: 6000,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
    navigation: {
      nextEl: '.bannerSwiper .swiper-control .swiper-button-next',
      prevEl: '.bannerSwiper .swiper-control .swiper-button-prev',
    },
    pagination: {
      el: '.bannerSwiper .swiper-control .swiper-pagination',
      clickable: true,
    },
  });
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });
  const tab = new KTab('[k-tab]', {
    onChangeAnchor: false,
    onChange: tab => {
      scrollTrigger.reset(tab.activePanelEl, '[k-st]');
      gsapAnimationUpdate();
    },
  });

  gsapAnimation();
  swiperHandler();
};

// Vue
createApp({
  setup() {
    // const reportDataRef = ref(reportData);
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {
      // reportDataRef,
    };
  },
}).mount('#main');
